import React from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import clsx from "clsx";
import { OperatedSwitchButton } from "../OperatedSwitchButton/OperatedSwitchButton";
import WeduTooltip from "../WeduTooltip/intex";
import IconButton from "../IconButton";
import FontIcon from "../FontIcon";

const useStyles = makeStyles((theme: Theme) => ({
  mainContainer: {},
  container: {
    display: "inline-flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  buttonCont: {
    "& + &": {
      marginLeft: 16,
    },
  },
  iconButton: {
    padding: 9,
    "& .MuiIcon-root": {
      fontSize: 14,
    },
  },
  switchButton: {
    height: 18,
  },
  addButton: {
    backgroundColor: theme.palette.success.main,
    color: "#FFF",
    padding: 9,
    "& .MuiIcon-root": {
      fontSize: 14,
    },
    "&:hover": {
      backgroundColor: theme.palette.success.dark,
    },
    "&:focus": {
      backgroundColor: theme.palette.success.dark,
    },
    "&:active": {
      backgroundColor: theme.palette.success.dark,
    },
  },
}));

interface Props {
  createCallBack?: any;
  createTooltip?: string;
  cloneCallBack?: any;
  cloneTooltip?: string;
  viewCallBack?: any;
  viewTooltip?: string;
  editCallBack?: any;
  editTooltip?: string;
  switchCallBack?: any;
  switchTooltipActive?: string;
  switchTooltipNotActive?: string;
  switchState?: boolean;
  isSwitchDisabled?: boolean;
  recoverCallBack?: any;
  recoverTooltip?: string;
  deleteCallBack?: any;
  deleteTooltip?: string;
  isDeleteDisabled?: boolean;
}

export const ActionBar = ({
  createCallBack,
  createTooltip,
  cloneCallBack,
  cloneTooltip,
  viewCallBack,
  viewTooltip,
  editCallBack,
  editTooltip,
  switchCallBack,
  switchTooltipActive,
  switchTooltipNotActive,
  switchState,
  isSwitchDisabled,
  recoverCallBack,
  recoverTooltip,
  deleteCallBack,
  deleteTooltip,
  isDeleteDisabled,
}: Props) => {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
      onClick={(event) => event.stopPropagation()}
    >
      {createCallBack && (
        <div className={classes.buttonCont}>
          <WeduTooltip title={createTooltip}>
            <IconButton
              className={classes.addButton}
              color={"info"}
              onClick={createCallBack}
            >
              <FontIcon name={"add"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {cloneCallBack && (
        <div className={classes.buttonCont}>
          <WeduTooltip title={cloneTooltip}>
            <IconButton
              className={classes.iconButton}
              color={"success"}
              onClick={cloneCallBack}
            >
              <FontIcon name={"copy"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {viewCallBack && (
        <div className={classes.buttonCont}>
          <WeduTooltip title={viewTooltip}>
            <IconButton
              className={classes.iconButton}
              color={"info"}
              onClick={viewCallBack}
            >
              <FontIcon name={"show"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {editCallBack && (
        <div className={classes.buttonCont}>
          <WeduTooltip title={editTooltip}>
            <IconButton
              className={classes.iconButton}
              color={"edit"}
              onClick={editCallBack}
            >
              <FontIcon name={"edit"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {switchCallBack && (
        <div className={clsx(classes.buttonCont, classes.switchButton)}>
          <WeduTooltip
            title={
              isSwitchDisabled
                ? ""
                : switchState
                  ? switchTooltipActive
                  : switchTooltipNotActive
            }
          >
            <OperatedSwitchButton
              checked={switchState}
              onChange={switchCallBack}
              disabled={isSwitchDisabled}
            />
          </WeduTooltip>
        </div>
      )}
      {recoverCallBack && (
        <div className={classes.buttonCont}>
          <WeduTooltip title={recoverTooltip}>
            <IconButton
              className={classes.iconButton}
              color={"success"}
              onClick={recoverCallBack}
            >
              <FontIcon name={"recover"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
      {deleteCallBack && (
        <div className={classes.buttonCont}>
          <WeduTooltip title={isDeleteDisabled ? "" : deleteTooltip}>
            <IconButton
              className={classes.iconButton}
              color={"delete"}
              onClick={deleteCallBack}
              disabled={isDeleteDisabled}
            >
              <FontIcon name={"delete"} />
            </IconButton>
          </WeduTooltip>
        </div>
      )}
    </div>
  );
};
